import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatUnitId'
})
export class FormatUnitIdPipe implements PipeTransform {
  transform(value: string | null): string {
    if (value?.startsWith('SHT') || value?.startsWith('PCS') || value?.startsWith('PAL')) {
      return value;
    }
    return value?.toLowerCase() || '';
  }
}
